import { render, staticRenderFns } from "./search-contacts.vue?vue&type=template&id=d413a700&scoped=true&"
import script from "./search-contacts.vue?vue&type=script&lang=js&"
export * from "./search-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d413a700",
  null
  
)

export default component.exports